import { InjectionToken } from '@angular/core';

export const ENV_MODULE_TOKEN = new InjectionToken<Record<string, string>>('ENV_MODULE_TOKEN');
